<template>
  <div class="dropdown-multiple-select-button">
    <p
      v-if="title"
      class="dropdown-multiple-select-menu-button_title"
    >
      {{ $t(title) }}<span
        v-if="required"
        class="red"
      >*</span>
    </p>
    <ValidationProvider
      v-slot="{ errors }"
      v-click-outside="$_dropdownClose"
      :rules="rules"
      class="dropdown-multiple-select-menu-button_content-wrap"
    >
      <input
        type="hidden"
        :value="value"
      >
      <div
        class="dropdown-multiple-select-menu-button_content"
        :class="{outline: outline, narrow: narrow,wide:wide,disabled:disabled,error:errors.length>0}"
      >
        <i
          v-if="leadingIcon"
          class="icon leading-icon"
          :class="leadingIcon"
        />
        <button
          class="input-button"
          @click="$_onclick()"
        >
          <p class="select">
            {{ _computedButtonTextLabel }}
          </p>
          <p
            v-if="_dropdownItems.length > 0 && value && value.length > 0"
            class="num"
          >
            {{ _remainNumber }}
          </p>
        </button>
        <i
          v-if="outline || disabled"
          class="icon trailing-icon outline icon-chevron-up"
          :class="{show: dropdown_menu_show}"
        />
        <i
          v-else-if="!outline && !dropdown_menu_show"
          class="icon trailing-icon icon-arrow-drop-down-circle"
        />
        <i
          v-else-if="!outline && dropdown_menu_show"
          class="icon trailing-icon icon-arrow-drop-up-circle"
        />
        <transition mode="out-in">
          <div
            v-if="dropdown_menu_show"
            class="dropdown-menu"
          >
            <div
              v-if="selectAll && _dropdownItems.length > 0"
              class="search-tool btn"
            >
              <button
                class="select-all-btn"
                @click="$_selectAll()"
              >
                <i
                  :class="_allBtnIcon"
                  class="select-all-btn-icon"
                /> <span>{{ $t('全部') }}</span>
              </button>
            </div>
            <div
              v-if="hasSearch"
              class="search-tool"
            >
              <SearchInput
                v-model="searchInputButton.value"
                :placeholder="searchInputButton.placeholder"
                :text-label="searchInputButton.textLabel"
                @enter="$_searchMemberByName()"
              />
            </div>
            <perfect-scrollbar class="ps dropdown-scrollable-content">
              <LvText v-if="_dropdownItems.length === 0" h6>{{ $t('無選項') }}</LvText>
              <div
                v-for="(firstLayer,firstLayerKey) in _dropdownItems"
                :key="firstLayerKey"
                class="classification-list"
              >
                <!-- First Layer -->
                <div class="classification-subtitle">
                  <label>
                    <input
                      type="checkbox"
                      :checked="value.includes(firstLayer.value)"
                      @change="$_onChange($event,firstLayer.value)"
                    >
                    <div class="checkbox-icon">
                      <i class="checked icon-check-box" />
                      <i class="unchecked icon-check-box-outline-blank" />
                    </div>
                    <span>{{ $t(firstLayer.text) }}</span>
                  </label>
                </div>
              </div>
            </perfect-scrollbar>
          </div>
        </transition>
      </div>
      <div
        v-if="errors.length > 0"
        class="invalid-text"
      >
        <i class="icon-warning invalid-icon" />
        <p
          v-for="(text_e,text_k) in errors"
          :key="text_k"
          class="text"
        >
          {{ $t(text_e) }}
        </p>
      </div>
    </ValidationProvider>
  </div>
</template>

<script>
import ClickOutside from "vue-click-outside";
import { ValidationProvider } from "vee-validate";
import { extend } from "vee-validate";
import { required } from "vee-validate/dist/rules";
extend("required", {
  ...required,
  message: "此項目為必填",
});
export default {
  name: "DropdownMultipleSelectButton",
  directives: {
    ClickOutside,
  },
  components: {
    ValidationProvider,
  },
  props: {
    rules: {
      type: String,
      default: "",
    },
    value: {
      type: Array,
      default() {
        return [];
      },
    },
    menuItems: {
      type: Array,
      default() {
        return [];
      },
    },
    leadingIcon: {
      type: String,
      default: "",
    },
    outline: {
      type: Boolean,
      default: false,
    },
    narrow: {
      type: Boolean,
      default: false,
    },
    wide: {
      type: Boolean,
      default: false,
    },
    placeholder: {
      type: String,
      default: '選擇',
    },
    title: {
      type: String,
      default: "",
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    required: {
      type: Boolean,
      default: false,
    },
    selectAll: {
      type: Boolean,
      default: true,
    },
    hasSearch: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      dropdown_menu_show: false,
      searchInputButton: {
        value: "",
        placeholder: this.$t("搜尋"),
        textLabel: this.$t("搜尋"),
      },
    };
  },
  computed: {
    _allBtnIcon() {
      const allValue = [];
      this.menuItems.forEach((menu) => {
        allValue.push(menu);
      });
      if (this.value.length < allValue.length && this.value.length > 0) {
        return "icon-indeterminate-check-box";
      } else if (this.value.length === 0) {
        return "icon-check-box-outline-blank";
      }
      return "icon-check-box";
    },
    _computedButtonTextLabel() {
      if (!this.menuItems || this.menuItems.length === 0) return this.$t('無選項');
      const selectedSet = new Set(this.value);
      const selectedItemList = this.menuItems.filter(item => selectedSet.has(item.value));
      if (selectedItemList.length === this.menuItems.length) return this.$t('全部');
      if (selectedItemList.length > 0) return selectedItemList.map(item => item.text).join('、');
      return this.placeholder ? this.$t(this.placeholder) : '';
    },
    _remainNumber() {
      return this.value.length;
    },
    _dropdownItems() {
      return this.$_searchMemberByName();
    },
  },
  methods: {
    $_selectAll() {
      const allArr = [];
      const allValue = [];
      this.menuItems.forEach((item) => {
        allValue.push(item);
      });
      if (this.value.length < allValue.length) {
        this.menuItems.forEach((item) => {
          allArr.push(item.value);
        });
      }
      this.$emit("input", allArr);
      this.$emit("click");
    },
    $_searchMemberByName() {
      let originalItems = [...this.menuItems];
      let searchOrigianlItems = originalItems.filter((item) => {
        return item.text
          .toLowerCase()
          .includes(this.searchInputButton.value.toLowerCase());
      });
      return searchOrigianlItems;
    },
    $_onclick() {
      if (this.disabled) return;
      this.$_toggleDropdownMenuShow();
    },
    $_toggleDropdownMenuShow() {
      this.dropdown_menu_show = !this.dropdown_menu_show;
    },
    $_dropdownClose() {
      this.dropdown_menu_show = false;
      this.addMemberActive = false;
    },
    $_onChange($event, value) {
      let newValue = JSON.parse(JSON.stringify(this.value));
      if ($event.target.checked) {
        if (!newValue.includes(value)) {
          newValue.push(value);
        }
      } else {
        newValue = newValue.filter((item) => item !== value);
      }
      this.$emit("input", newValue);
      this.$emit("click");
    },
  },
};
</script>
<style lang="scss">
@import "@/assets/scss/component/dropdown-multiple-select-button";
</style>